import { Button, type ButtonVariant } from '@/app/common/Buttons/Button';
import { getButtonVariant, shouldOpenInNewTab } from '@workspace/lib';
import { stripInvisibles } from '@workspace/constants';
import { cn } from '@workspace/lib';
import type { ApplicationsBlockButton } from '../application.types';

export const renderButtons = (buttons: ApplicationsBlockButton[] | undefined) => {
  if (!buttons?.length) return null;

  return (
    <div className={cn('flex gap-3 flex-wrap w-full max-md:w-full justify-center')}>
      {buttons.map((btn, idx) => {
        const variant: ButtonVariant = getButtonVariant(btn.style);
        const label = stripInvisibles(btn.label || 'Button').trim() || 'Button';

        if (!btn?.link?.url) {
          return (
            <Button
              key={idx}
              isDisabled
              variant={variant}
              className="max-md:w-full md:min-w-5xl md:w-max"
              openInNewTab={shouldOpenInNewTab(btn?.link)}
            >
              {label}
            </Button>
          );
        }

        return (
          <Button
            key={idx}
            variant={variant}
            url={btn?.link?.url}
            openInNewTab={shouldOpenInNewTab(btn?.link)}
            className="max-md:w-full md:min-w-5xl md:w-max"
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
};
